<template>
  <div style="padding: 20px">
    <a-row>
      <a-col
        :span="24"
        :lg="24"
        :xl="24"
        class="mb-24"
        style="display: flex; align-items: center; justify-content: flex-end"
      >
        <a-radio-group
          v-model:value="dateType"
          button-style="solid"
          @change="dateTypeChange"
          size="small"
        >
          <a-radio-button value="0">前天</a-radio-button>
          <a-radio-button value="1">最近一周</a-radio-button>
          <a-radio-button value="2">最近一月</a-radio-button>
          <a-radio-button value="3">最近一年</a-radio-button>
          <a-radio-button value="4">全部</a-radio-button>
        </a-radio-group>
      </a-col>
    </a-row>

    <div class="my-charts" ref="myChart"></div>
  </div>
</template>

<script>
import { getLastTop, getWeekChartByKeyWord } from "@/api/charts.js";
export default {
  data() {
    return {
      dateType: "0",
      chart: null,
      wciYAxis: {},
      tkYAxis: {},
      adScore: [],
      extlinkScore: [],
      liveScore: [],
      mpdocScore: [],
      queryScore: [],
      finderScore: [],
      w1wScore: [],
      loading: null,
      wcichartData: [],
      tkchartData: [],
      tk_searchScore: [],
      tk_topScore: [],
    };
  },
  mounted() {
    window.addEventListener("resize", this.handleResize);
    this.GetDate();
  },
  methods: {
    GetDate() {
      this.loading = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      getLastTop(this.dateType).then((res) => {
        if (res.code == 0) {
          this.wcichartData = res.data.wciList;
          this.wciYAxis = this.wcichartData.map((item) => item.keyword);
          this.adScore = this.wcichartData.map((item) => item.adScore);
          this.extlinkScore = this.wcichartData.map(
            (item) => item.extlinkScore
          );
          this.liveScore = this.wcichartData.map((item) => item.liveScore);
          this.mpdocScore = this.wcichartData.map((item) => item.mpdocScore);
          this.queryScore = this.wcichartData.map((item) => item.queryScore);
          this.finderScore = this.wcichartData.map((item) => item.finderScore);
          this.w1wScore = this.wcichartData.map((item) => item.w1wScore);

          this.tkchartData = res.data.tkList;
          this.tkYAxis = this.tkchartData.map((item) => item.keyword);
          this.tk_searchScore = this.tkchartData.map(
            (item) => item.searchScore
          );
          this.tk_topScore = this.tkchartData.map((item) => item.topScore);

          this.$emit("chartDataChanged", this.wcichartData, this.tkchartData);
          this.InitOptions();
        }
        this.loading.close();
      });
    },
    InitOptions() {
      this.chart = this.$echarts.init(this.$refs.myChart);
      // 添加点击事件监听器
      this.chart.off("click");
      this.chart.on("click", (params) => {
        if (params.componentType === "yAxis") {
          this.handleYAxisClick(params);
        } else if (params.componentType === "series") {
          this.handleSeriesClick(params);
        }
      });
      this.chart.setOption({
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            label: {
              backgroundColor: "#6a7985",
            },
          },
          position: function (pos, params, el, elRect, size) {
            const obj = {
              top: 10,
            };
            obj[["left", "right"][+(pos[0] < size.viewSize[0] / 2)]] = 30;
            return obj;
          },
          formatter: (params) => {
            if (!params || params.length === 0) return "";

            // 使用div包裹所有内容，添加基本样式
            let result = `<div style="padding: 8px;">`;

            // 添加标题，使用粗体和更大的字号
            result += `<div style="font-weight: bold; font-size: 14px; margin-bottom: 8px;">${params[0].name}</div>`;

            // 过滤并处理上图数据
            const leftParams = params.filter((item) => item.axisIndex === 0);
            if (leftParams.length > 0) {
              // 计算总计值，添加安全检查
              const total = leftParams.reduce(
                (sum, item) => sum + (parseFloat(item.value) || 0),
                0
              );

              // 添加每个数据项，使用flex布局对齐
              leftParams.forEach((item) => {
                const value = parseFloat(item.value) || 0;
                result += `<div style="display: flex; justify-content: space-between; margin: 2px 0; min-width: 180px;">
        <span style="display: flex; align-items: center;">${item.marker}${
                  item.seriesName
                }</span>
        <span style="font-weight: 500;">${value.toLocaleString()}</span>
      </div>`;
              });

              // 添加分隔线和总计，使用不同的样式突出显示
              result += `<div style="margin: 6px 0; border-top: 1px solid #ddd;"></div>
    <div style="display: flex; justify-content: space-between; font-weight: bold; color: #1890ff;">
      总计
      <span>${total.toLocaleString()}</span>
    </div>`;
            }

            // 过滤并处理下图数据，如果存在则添加分隔线和数据
            const rightParams = params.filter((item) => item.axisIndex === 1);
            if (rightParams.length > 0) {
              // 计算总计值，添加安全检查
              const total = rightParams.reduce(
                (sum, item) => sum + (parseFloat(item.value) || 0),
                0
              );

              // 添加每个数据项，使用flex布局对齐
              rightParams.forEach((item) => {
                const value = parseFloat(item.value) || 0;
                result += `<div style="display: flex; justify-content: space-between; margin: 2px 0; min-width: 180px;">
        <span style="display: flex; align-items: center;">${item.marker}${
                  item.seriesName
                }</span>
        <span style="font-weight: 500;">${value.toLocaleString()}</span>
      </div>`;
              });

              // 添加分隔线和总计，使用不同的样式突出显示
              result += `<div style="margin: 6px 0; border-top: 1px solid #ddd;"></div>
    <div style="display: flex; justify-content: space-between; font-weight: bold; color: #1890ff;">
      总计
      <span>${total.toLocaleString()}</span>
    </div>`;
            }

            // 关闭外层div
            result += `</div>`;
            return result;
          },
        },
        legend: {},
        // 定义左右两个图表区域
        grid: [
          {
            left: "5%",
            right: "60%",
            bottom: "10%",
          },
          {
            left: "55%",
            right: "5%",
            bottom: "10%",
          },
        ],
        // 配置左右两个x轴
        xAxis: [
          {
            type: "value",
            gridIndex: 0,
            min: 0,
            axisLabel: {
              formatter: function (value) {
                // 超过1亿用b
                if (value >= 100000000) {
                  return value / 100000000 + " B";
                }
                // 超过1百万用m
                else if (value >= 1000000) {
                  return value / 1000000 + " M";
                }
                // 超过1千用k
                else if (value >= 1000) {
                  return value / 1000 + " K";
                }
                // 小于1千直接返回原值
                return value;
              },
            },
          },
          {
            type: "value",
            gridIndex: 1,
            min: 0,
            axisLabel: {
              formatter: function (value) {
                // 超过1亿用b
                if (value >= 100000000) {
                  return value / 100000000 + " B";
                }
                // 超过1百万用m
                else if (value >= 1000000) {
                  return value / 1000000 + " M";
                }
                // 超过1千用k
                else if (value >= 1000) {
                  return value / 1000 + " K";
                }
                // 小于1千直接返回原值
                return value;
              },
            },
          },
        ],
        // 配置左右两个y轴
        yAxis: [
          {
            type: "category",
            data: this.wciYAxis,
            axisPointer: {
              show: true,
            },
            triggerEvent: true,
            gridIndex: 0,
          },
          {
            type: "category",
            data: this.tkYAxis,
            axisPointer: {
              show: true,
            },
            triggerEvent: true,
            gridIndex: 1,
          },
        ],
        series: [
          {
            name: "WCI广告",
            type: "bar",
            stack: "total",
            label: {
              show: false,
            },
            emphasis: {
              focus: "series",
            },
            data: this.adScore,
            xAxisIndex: 0,
            yAxisIndex: 0,
          },
          {
            name: "WCI外链",
            type: "bar",
            stack: "total",
            label: {
              show: false,
            },
            emphasis: {
              focus: "series",
            },
            data: this.extlinkScore,
            xAxisIndex: 0,
            yAxisIndex: 0,
          },
          {
            name: "WCI直播",
            type: "bar",
            stack: "total",
            label: {
              show: false,
            },
            emphasis: {
              focus: "series",
            },
            data: this.liveScore,
            xAxisIndex: 0,
            yAxisIndex: 0,
          },
          {
            name: "WCI公众号",
            type: "bar",
            stack: "total",
            label: {
              show: false,
            },
            emphasis: {
              focus: "series",
            },
            data: this.mpdocScore,
            xAxisIndex: 0,
            yAxisIndex: 0,
          },
          {
            name: "WCI搜一搜",
            type: "bar",
            stack: "total",
            label: {
              show: false,
            },
            emphasis: {
              focus: "series",
            },
            data: this.queryScore,
            xAxisIndex: 0,
            yAxisIndex: 0,
          },
          {
            name: "WCI问一问",
            type: "bar",
            stack: "total",
            label: {
              show: false,
            },
            emphasis: {
              focus: "series",
            },
            itemStyle: {
              color: "#00ff00",
            },
            data: this.w1wScore,
            xAxisIndex: 0,
            yAxisIndex: 0,
          },
          {
            name: "WCI视频号",
            type: "bar",
            stack: "total",
            label: {
              show: false,
            },
            emphasis: {
              focus: "series",
            },
            itemStyle: {
              color: "#ff0000",
            },
            data: this.finderScore,
            xAxisIndex: 0,
            yAxisIndex: 0,
          },
          {
            name: "TK搜索",
            type: "bar",
            stack: "total1",
            label: {
              show: false,
            },
            emphasis: {
              focus: "series",
            },
            itemStyle: {
              color: "#ff0000",
            },
            data: this.tk_searchScore,
            xAxisIndex: 1,
            yAxisIndex: 1,
          },
          {
            name: "TK综合",
            type: "bar",
            stack: "total1",
            label: {
              show: false,
            },
            emphasis: {
              focus: "series",
            },
            itemStyle: {
              color: "#ff11a1",
            },
            data: this.tk_topScore,
            xAxisIndex: 1,
            yAxisIndex: 1,
          },
        ],
      });
    },

    dateTypeChange() {
      this.GetDate();
    },
    handleResize() {
      if (this.chart) {
        this.chart.resize();
      }
    },
    handleYAxisClick(params) {
      console.log(params);
      const clickedKeyword = params.value;
      if (
        clickedKeyword &&
        this.wcichartData.length > 0 &&
        this.tkchartData.length > 0
      ) {
        var matchedItem = null;
        if (params.yAxisIndex === 0) {
          matchedItem = this.wcichartData.find(
            (item) => item.keyword === clickedKeyword
          );
        } else if (params.yAxisIndex === 1) {
          matchedItem = this.tkchartData.find(
            (item) => item.keyword === clickedKeyword
          );
        }

        if (matchedItem) {
          console.log("匹配到的项目:", matchedItem);
          try {
            // 直接构建完整URL，不依赖Vue Router的resolve方法
            const baseUrl = window.location.origin + window.location.pathname;
            const queryString = `?id=${matchedItem.keyId}`;
            const fullUrl = baseUrl + "#/keyword-chart" + queryString;

            console.log("直接构建的完整URL:", fullUrl);

            // 添加防缓存参数
            const timestamp = new Date().getTime();
            const urlWithTimestamp =
              fullUrl + (fullUrl.includes("?") ? "&" : "?") + `t=${timestamp}`;

            const newWindow = window.open(urlWithTimestamp, "_blank");

            if (newWindow === null || typeof newWindow === "undefined") {
              console.warn("新窗口可能被浏览器阻止，尝试使用备选方案");
              window.location.href = urlWithTimestamp;
            }
          } catch (error) {
            console.error("跳转错误:", error);
            this.$router.push({
              path: "/keyword-chart",
              query: { id: matchedItem.keyId },
            });
          }
        }
      }
    },
    handleSeriesClick(params) {
      const clickedKeyword = params.name;
      if (
        clickedKeyword &&
        this.wcichartData.length > 0 &&
        this.tkchartData.length > 0
      ) {
        var matchedItem = null;
        if (params.seriesName.includes("WCI") || params.seriesIndex < 7) {
          ///这是微信指数
          matchedItem = this.wcichartData.find(
            (item) => item.keyword === clickedKeyword
          );
          if (matchedItem) {
            this.$emit("ChartItemClick", matchedItem.keyId, "wci");
          }
        } else if (
          params.seriesName.includes("TK") ||
          params.seriesIndex >= 7
        ) {
          ///这是抖音指数
          matchedItem = this.tkchartData.find(
            (item) => item.keyword === clickedKeyword
          );
          if (matchedItem) {
            this.$emit("ChartItemClick", matchedItem.keyId, "tk");
          }
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.my-charts {
  width: 100%; // 设置宽度为100%，使其适应父容器
  height: 700px; // 设置固定高度，可根据需要调整
  min-height: 500px; // 设置最小高度，确保在小屏幕上也能显示
}
</style>